import { useEffect, useState } from "react";

export class SimpleObservable<T>{
    private observers: ((value: T) => void)[] = [];
    private value: T;

    constructor(value: T) {
        this.value = value;
    }

    public getValue() {
        return this.value;
    }

    public setValue(value: T) {
        this.value = value;
        this.observers.forEach(x => x(value));
    }

    public observe(callback: (value: T) => void): () => void {
        this.observers.push(callback);
        return () => {
            this.observers = this.observers.filter(x => x !== callback);
        }
    }

    public forceUpdate() {
        this.observers.forEach(x => x(this.value));
    }
}

export const useObservableValue = <T>(observable: SimpleObservable<T>|T) => {
    const [, setCounter] = useState(0);
    const [value, setValue] = useState<T>(observable instanceof SimpleObservable ? observable.getValue() : observable);

    useEffect(() => {
        if(observable instanceof SimpleObservable){
            setValue(observable.getValue());
            const unregister = observable.observe((newValue) => {
                setCounter(x => x + 1);
                setValue(newValue);
            });
            return () => {
                unregister();
            };
        }
        else{
            setValue(observable);
        }
    }, [observable]);

    return value;
}